document.addEventListener('DOMContentLoaded', function () {
  var engravingRoot = document.querySelector('.bm-engraving');
  if (!engravingRoot) return;

  var form = document.querySelector('form.product-single__form[action*="/cart/add"]');
  if (!form) return;

  var textInputs = engravingRoot.querySelectorAll('.bm-engraving__text-input');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var maxSymbols = parseInt(engravingRoot.getAttribute('data-max-symbols'), 10) || 8;

  var singleModeRoot = engravingRoot.querySelector('[data-symbol-mode="single"]');
  var sequenceModeRoot = engravingRoot.querySelector('[data-symbol-mode="sequence"]');
  var presetPhraseRoot = engravingRoot.getAttribute('data-phrase-mode') === 'preset' ? engravingRoot : null;

  var selectedSingleSymbol = null;
  var sequenceSymbols = [];

  function removeExistingClones() {
    var clones = form.querySelectorAll('input[data-engraving-clone="true"]');
    Array.prototype.forEach.call(clones, function (el) {
      el.remove();
    });
  }

  function appendHiddenInput(name, value) {
    if (!value) return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-engraving-clone', 'true');
    form.appendChild(input);
  }

  function injectEngravingHiddenInputs() {
    removeExistingClones();

    // ── Preset phrase mode ──────────────────────────────
    if (presetPhraseRoot) {
      var phraseSelect = presetPhraseRoot.querySelector('[data-phrase-select]');
      if (phraseSelect && phraseSelect.value) {
        var selectedOpt = phraseSelect.options[phraseSelect.selectedIndex];
        appendHiddenInput('properties[Engraving phrase]', phraseSelect.value);

        var font = selectedOpt.getAttribute('data-phrase-font');
        if (font) appendHiddenInput('properties[Engraving font]', font);

        var symbolSrc = selectedOpt.getAttribute('data-phrase-symbol-src');
        if (symbolSrc) appendHiddenInput('properties[Engraving symbol src]', symbolSrc);

        var fileUrl = selectedOpt.getAttribute('data-phrase-file');
        if (fileUrl) appendHiddenInput('properties[Engraving file]', fileUrl);
      }
      return;
    }
    // ────────────────────────────────────────────────────

    Array.prototype.forEach.call(textInputs, function (src) {
      var value = (src.value || '').trim();
      if (!value) return;
      appendHiddenInput(src.name, value);
    });

    if (selectedSingleSymbol) {
      appendHiddenInput('properties[Engraving symbol key]', selectedSingleSymbol.key);
      appendHiddenInput('properties[Engraving symbol label]', selectedSingleSymbol.label);
    }

    if (sequenceModeRoot && sequenceSymbols.length) {
      var keys = [];
      var labels = [];

      sequenceSymbols.forEach(function (symbol) {
        keys.push(symbol.key);
        labels.push(symbol.label);
      });

      appendHiddenInput('properties[Engraving symbols keys]', keys.join('|'));
      appendHiddenInput('properties[Engraving symbols labels]', labels.join('|'));
    }
  }

  function validateEngraving() {
    // ── Preset phrase mode ──────────────────────────────
    if (presetPhraseRoot) {
      var phraseSelect = presetPhraseRoot.querySelector('[data-phrase-select]');
      if (!phraseSelect || !phraseSelect.value) {
        alert('Please select an engraving phrase.');
        if (phraseSelect) phraseSelect.focus();
        return false;
      }
      return true;
    }
    // ────────────────────────────────────────────────────

    if (sequenceModeRoot) {
      if (!sequenceSymbols.length) {
        alert('Please choose at least one symbol.');
        return false;
      }
      return true;
    }

    if (textInputs.length) {
      var first = textInputs[0];
      if (!first.value || !first.value.trim().length) {
        first.focus();
        alert('Please enter engraving text.');
        return false;
      }
    }

    return true;
  }

  function getSymbolData(button) {
    return {
      key: button.getAttribute('data-symbol-key') || '',
      label: button.getAttribute('data-symbol-label') || '',
      src: button.getAttribute('data-symbol-src') || ''
    };
  }

  function buildImageNode(src, alt, className) {
    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';
    img.className = className || '';
    img.loading = 'lazy';
    return img;
  }

  function createEmptyState(text) {
    var emptyState = document.createElement('span');
    emptyState.className = 'bm-engraving__empty';
    emptyState.textContent = text;
    return emptyState;
  }


  // ── Preset phrase mode ────────────────────────────────
  function initPresetPhraseMode() {
    if (!presetPhraseRoot) return;

    var phraseSelect = presetPhraseRoot.querySelector('[data-phrase-select]');

    if (!phraseSelect) return;

    // preview removed
  }
  // ─────────────────────────────────────────────────────

  function initSingleMode() {
    if (!singleModeRoot) return;

    var buttons = singleModeRoot.querySelectorAll('[data-symbol-item]');
    var preview = singleModeRoot.querySelector('[data-single-preview]');
    var previewSymbol = singleModeRoot.querySelector('[data-preview-symbol]');
    var previewText = singleModeRoot.querySelector('[data-preview-text]');
    var lineOneInput = singleModeRoot.querySelector('.bm-engraving__text-input');

    function clearSingleSymbol(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      selectedSingleSymbol = null;

      Array.prototype.forEach.call(buttons, function (item) {
        item.classList.remove('is-selected');
      });

      renderSinglePreview();
    }

    function renderSinglePreview() {
      var textValue = lineOneInput ? (lineOneInput.value || '').trim() : '';
      var hasContent = !!selectedSingleSymbol || !!textValue;

      preview.classList.toggle('is-active', hasContent);
      previewSymbol.innerHTML = '';
      previewText.innerHTML = '';

      if (!hasContent) {
        return;
      }

      if (selectedSingleSymbol) {
        var symbolChip = document.createElement('span');
        symbolChip.className = 'bm-engraving__composer-symbol-chip';

        if (selectedSingleSymbol.src) {
          symbolChip.appendChild(
            buildImageNode(
              selectedSingleSymbol.src,
              selectedSingleSymbol.label,
              'bm-engraving__composer-symbol-image'
            )
          );
        } else if (selectedSingleSymbol.label) {
          var fallbackSymbol = document.createElement('span');
          fallbackSymbol.className = 'bm-engraving__composer-symbol-fallback';
          fallbackSymbol.textContent = selectedSingleSymbol.label;
          symbolChip.appendChild(fallbackSymbol);
        }

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'bm-engraving__composer-symbol-remove';
        removeBtn.setAttribute('aria-label', 'Remove symbol');
        removeBtn.textContent = '×';

        symbolChip.appendChild(removeBtn);
        previewSymbol.appendChild(symbolChip);
      }

      if (textValue) {
        previewText.textContent = textValue;
      } else {
        previewText.appendChild(createEmptyState('Symbol selected'));
      }
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var clickedKey = button.getAttribute('data-symbol-key');

        if (selectedSingleSymbol && selectedSingleSymbol.key === clickedKey) {
          clearSingleSymbol();
          return;
        }

        selectedSingleSymbol = getSymbolData(button);

        Array.prototype.forEach.call(buttons, function (item) {
          item.classList.remove('is-selected');
        });

        button.classList.add('is-selected');
        renderSinglePreview();
      });
    });

    preview.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('.bm-engraving__composer-symbol-remove');
      if (!removeBtn) return;

      clearSingleSymbol(event);
    });

    if (lineOneInput) {
      lineOneInput.addEventListener('input', renderSinglePreview);
    }

    renderSinglePreview();
  }

  function initSequenceMode() {
    if (!sequenceModeRoot) return;

    var buttons = sequenceModeRoot.querySelectorAll('[data-symbol-item]');
    var preview = sequenceModeRoot.querySelector('[data-sequence-preview]');
    var count = sequenceModeRoot.querySelector('[data-sequence-count]');
    var clearBtn = sequenceModeRoot.querySelector('[data-sequence-clear]');

    function renderSequencePreview() {
      preview.innerHTML = '';
      preview.classList.remove('is-empty');

      if (!sequenceSymbols.length) {
        preview.classList.add('is-empty');
        preview.appendChild(createEmptyState('Tap symbols below to add.'));
      } else {
        sequenceSymbols.forEach(function (symbol, index) {
          var item = document.createElement('span');
          item.className = 'bm-engraving__sequence-item';

          if (symbol.src) {
            item.appendChild(buildImageNode(symbol.src, symbol.label, 'bm-engraving__sequence-image'));
          } else {
            var fallbackSymbol = document.createElement('span');
            fallbackSymbol.className = 'bm-engraving__sequence-fallback';
            fallbackSymbol.textContent = symbol.label;
            item.appendChild(fallbackSymbol);
          }

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bm-engraving__sequence-remove';
          removeBtn.setAttribute('data-sequence-remove', index);
          removeBtn.setAttribute('aria-label', 'Remove symbol');
          removeBtn.textContent = '×';
          item.appendChild(removeBtn);

          preview.appendChild(item);
        });
      }

      if (count) {
        count.textContent = sequenceSymbols.length + ' / ' + maxSymbols;
      }
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        if (sequenceSymbols.length >= maxSymbols) {
          alert('You can add up to ' + maxSymbols + ' symbols.');
          return;
        }

        sequenceSymbols.push(getSymbolData(button));
        renderSequencePreview();
      });
    });

    preview.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-sequence-remove]');
      if (!removeBtn) return;

      var index = parseInt(removeBtn.getAttribute('data-sequence-remove'), 10);
      if (isNaN(index)) return;

      sequenceSymbols.splice(index, 1);
      renderSequencePreview();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        sequenceSymbols = [];
        renderSequencePreview();
      });
    }

    renderSequencePreview();
  }


  initPresetPhraseMode();
  initSingleMode();
  initSequenceMode();

  form.addEventListener('submit', function (event) {
    if (!validateEngraving()) {
      event.preventDefault();
      return;
    }

    injectEngravingHiddenInputs();
  }, true); // capture:true — must run before theme.js serialize

  if (addBtn) {
    addBtn.addEventListener(
      'click',
      function (event) {
        if (!validateEngraving()) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          return;
        }

        injectEngravingHiddenInputs();
      },
      true
    );
  }
});